export const DIMENSION_META = [
  { key: 'engagement', label: 'Engagement' },
  { key: 'consistency', label: 'Consistency' },
  { key: 'diversityInclusivity', label: 'Diversity & Inclusivity' },
  { key: 'behavioralAnalysis', label: 'Behavior' },
  { key: 'communityImpact', label: 'Community Impact' },
  { key: 'contentQuality', label: 'Content Quality' },
  { key: 'innovativeness', label: 'Innovativeness' },
  { key: 'expertise', label: 'Expertise' },
] as const;

/**
 * Single rounding source of truth for a reputation score shown in the UI.
 * Whole number — matches ReputationGauge and keeps every surface consistent
 * (the hovercard used to render the raw URG float, e.g. 56.47790055248618).
 */
export function formatScore(score: number): number {
  return Math.round(score);
}

export function isPlaceholderReputation(
  rep: { source?: string } | null | undefined,
): boolean {
  return !rep || rep.source !== 'URG';
}

// TRIL-403: attribution caption shown under the gauge when a vouch boost is active.
export const vouchCaption = (earned: number, vouched: number) =>
  `${earned} earned + ${vouched} vouched`;

export function hasEvidence(
  rep: { evidence?: Record<string, string[]> } | null | undefined,
): boolean {
  if (!rep?.evidence) return false;
  return Object.values(rep.evidence).some(
    (arr) => Array.isArray(arr) && arr.length > 0,
  );
}
